import React, { Component } from 'react'

export default class Dev extends Component {
  render() {
    return (
      <div>
        
      </div>
    )
  }
}
